import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../../APIHelpers/Responses";

export const blogSubCategoryServices = {
  addNewBlogSubCategory,
  updatedBlogSubCategory,
  softDeleteRestoreBlogSubCategory,
  deleteBlogSubCategory,
  getBlogSubCategoryList,
};

// Add New Blog Category
async function addNewBlogSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewBlogSubCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Blog Category
async function updatedBlogSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedBlogSubCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Blog Category
async function softDeleteRestoreBlogSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreBlogSubCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Blog Category
async function deleteBlogSubCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteBlogSubCategory`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Blog Category
async function getBlogSubCategoryList(categoryId, status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getBlogSubCategoryList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getBlogSubCategoryList/${categoryId}/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getBlogSubCategoryList/${categoryId}/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}